import Model from "../Model";

class KpiComercialZone extends Model{

    buildUrl ({ param }) {
        return ['kpizone/getdimensionbyzoneregion', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiComercialZone;